import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorCalc.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import depthMove from 'routes/vendorRe/images/depth_move_icon.png';
import {
    commonBgColor,
    commonBodyPadding,
    commonFontWeight700,
    commonH1Padding,
    commonH1Size,
    contentCenter,
    contentEnd,
    contentStart,
    infoEm,
    infoFontColor1,
    infoFontColor2,
    infoFontColor3,
    infoFontSize1,
    statsOuterPadding,
    statsPaddingEnd,
    statsPaddingMiddle,
    statsPaddingStart,

} from 'routes/vendorRe/constraint/constraints';
import { requester } from 'App';
import useLocalStorage from 'shared/hooks/useLocalStorage';
import { getTokenPayload } from 'shared/utils/Utils';

const VendorCalc = (props) => {
    const [isMounted, setMounted] = useState(false);
    const [displayYear, setDisplayYear] = useState(new Date().getFullYear());
    const [displayMonth, setDisplayMonth] = useState(new Date().getMonth() + 1);
    const [settlementData, setSettlementData] = useState({
        totalPrice: 0,
        totalsupplyPrice: 0,
        cardCommissionFee: 0,
        serverUsageFee: 0,
        vat: 0,
        settlementAmount: 0
    });

    const [token, setToken] = useLocalStorage("token");

    const payload = getTokenPayload(token);

    // 월 단위로 데이터를 조회하고 업데이트하는 함수
    const updateMonth = (direction) => {
        let newMonth = displayMonth + direction;
        let newYear = displayYear;

        if (newMonth < 1) {
            newMonth = 12;
            newYear -= 1;
        } else if (newMonth > 12) {
            newMonth = 1;
            newYear += 1;
        }

        setDisplayMonth(newMonth);
        setDisplayYear(newYear);

        requester.getVendorSettlementFeeByYearAndMonth({
            year: newYear,
            month: newMonth
        }, (result) => {
            if (result.code === 0) {
                setSettlementData(result.data);
            }
        });
    };

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFeeByYearAndMonth({
                year: displayYear,
                month: displayMonth
            }, (result) => {
                if (result.code === 0) {
                    setSettlementData(result.data);
                }
            });

            requester.getVendorStatisticsAboveThreshold({
                endDate: "2025-02-28",
                startDate: "2025-02-01",
                vendorId: payload.userId,
                timeUnit: "month"
            }, (result) =>{
                if (result.code === 0) {
                    console.log(result.data);
                }
            }
            );
        }
    }, [isMounted]);

    return (
        <Container backgroundColor={commonBgColor} height={props.web ? null : "90vh"}>
            {/* <div style={{height: "10vh"}}></div> */}
            <VerticalFlex backgroundColor={commonBgColor}>
                <FlexChild padding={props.web ? null : commonBodyPadding} alignItems={contentStart}>
                    <VerticalFlex>
                        <FlexChild alignItems={contentStart}>
                            {
                                props.web ?
                                    null
                                    :
                                    <P padding={commonH1Padding} size={commonH1Size}>정산 금액 조회</P>

                            }

                            <VerticalFlex backgroundColor="white" borderRadius={infoEm} padding={statsOuterPadding} >
                                <FlexChild padding={statsPaddingStart}>
                                    <HorizontalFlex>
                                        <FlexChild justifyContent={contentStart}>
                                            <img
                                                style={{ transform: "rotate(180deg)" }}
                                                className={styles.depthMove}
                                                src={depthMove}
                                                alt='뎁스 이동'
                                                onClick={() => updateMonth(-1)} // 좌측 이미지 클릭 시 이전 월로 이동
                                            />
                                        </FlexChild>
                                        <FlexChild justifyContent={contentCenter} width={"max-content"}>
                                            <P weight={commonFontWeight700} size={"min(3.3vw, 25px)"} >
                                            {displayYear}년 {new Date(displayYear, displayMonth - 1).toLocaleString('ko-KR', { month: 'long' })} 정산 예정 금액
                                            </P>
                                        </FlexChild>
                                        <FlexChild justifyContent={contentEnd}>
                                            <img
                                                className={styles.depthMove}
                                                src={depthMove}
                                                alt='뎁스 이동'
                                                onClick={() => updateMonth(1)} // 우측 이미지 클릭 시 다음 월로 이동
                                            />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <div className={styles.borderTop}>
                                        <VerticalFlex>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <P size={infoFontSize1} color={infoFontColor1}>이달 매출</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {settlementData?.totalPrice?.toLocaleString() || 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <P size={infoFontSize1} color={infoFontColor1}>물품 대금</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {settlementData?.totalsupplyPrice ? (`- `) + settlementData?.totalsupplyPrice.toLocaleString() : 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <P size={infoFontSize1} color={infoFontColor1}>카드 수수료</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {settlementData?.cardCommissionFee ? '- ' + settlementData?.cardCommissionFee.toLocaleString() : 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <P size={infoFontSize1} color={infoFontColor1}>부가세</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {settlementData?.vat ? '- ' + settlementData?.vat.toLocaleString() : 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingEnd}>
                                                <HorizontalFlex>
                                                    <FlexChild flex="3">
                                                        <P size={infoFontSize1} color={infoFontColor3}>이번달 정산예정 금액</P>
                                                    </FlexChild>
                                                    <FlexChild flex="1" justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor2}>
                                                            {settlementData?.settlementAmount?.toLocaleString() || 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                {/* 빈 공간용 더미, 이게 없으면 높이 무너짐 */}
                <FlexChild></FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorCalc;